import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Row,
  Col,
  Button,
  Input,
  Label,
  Form,
  FormGroup,
  FormFeedback,
} from "reactstrap";
import { ClosableImage } from "../../../../../components";
import { FilePond, registerPlugin } from "react-filepond";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
registerPlugin(FilePondPluginImagePreview, FilePondPluginFileValidateType);
import { validateOffer } from "../_validate";
import { Field, reduxForm, change, formValueSelector } from "redux-form";
import DatePicker from "react-datepicker";
import moment from "moment";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { normalizeHelper, formatHelper } from "../../../../../common/helpers";

class FormOffer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeItem: {
        price: null,
      },
    };
    this.onSubmitOffer = this.onSubmitOffer.bind(this);
    this.renderInputField = this.renderInputField.bind(this);
    this.renderInputFile = this.renderInputFile.bind(this);
    this.renderOfferImage = this.renderOfferImage.bind(this);
    this.renderExpirationDatePicker =
      this.renderExpirationDatePicker.bind(this);
  }
  componentDidUpdate() {
    this.checkItemsChange();
  }
  toggleModal(itemType) {
    this.props.toggleModal(itemType);
  }
  onSubmitOffer(values) {
    this.props.onSubmitOffer(values);
  }

  changeImage(file) {
    this.props.changeImage(file);
  }
  changeImageState(withCurrentImage, currentImageRemoved) {
    this.props.changeImageState(withCurrentImage, currentImageRemoved);
  }
  renderInputFile() {
    return (
      <FormGroup row>
        <Col md="2" lg="3">
          <Label>Foto:</Label>
        </Col>
        <Col xs="12" md="5">
          <FilePond
            ref={(ref) => (this.pond = ref)}
            labelIdle='Arrastra y Suelta una imagen o <span class="filepond--label-action"> Elige </span>'
            acceptedFileTypes="image/jpeg, image/png"
            labelFileTypeNotAllowed="Archivo no válido"
            onupdatefiles={(fileItems) => {
              if (fileItems.length == 0) return;
              this.changeImage(fileItems[0].file);
            }}
            onremovefile={(file) => {
              this.changeImage(null);
            }}
          />
        </Col>
      </FormGroup>
    );
  }
  renderOfferImage() {
    return (
      <FormGroup row>
        <Col md="2" lg="3">
          <Label>Imagen:</Label>
        </Col>
        <Col xs="12" md="5">
          <ClosableImage
            src={this.props.initialValues.imageUrl}
            onClose={(e) => {
              e.preventDefault();
              this.changeImageState(false, true);
            }}
          />
        </Col>
      </FormGroup>
    );
  }

  renderStartDatePicker({ input, meta: { touched, error }, label }) {
    const className =
      touched && error ? "form-control is-invalid" : "form-control";
    const hasError = touched && error ? true : false;
    return (
      <FormGroup row style={{ zIndex: 11 }}>
        <Col md="2" lg="3">
          <Label>{label}</Label>
        </Col>
        <Col md="9">
          <DatePicker
            selected={
              input.value
                ? moment.parseZone(new Date(input.value), "DD/MM/YYYY")
                : null
            }
            onChange={input.onChange}
            className={className}
            dateFormat={"DD/MM/YYYY"}
            showYearDropdown
            showMonthDropdown
            locale="es-PE"
            minDate={moment(new Date())}
            style={{ zIndex: 12 }}
          />
          {hasError == true ? <FormFeedback>{error}</FormFeedback> : null}
        </Col>
      </FormGroup>
    );
  }
  renderExpirationDatePicker({ input, meta: { touched, error } }) {
    const className =
      touched && error ? "form-control is-invalid" : "form-control";
    const hasError = touched && error ? true : false;
    return (
      <FormGroup row style={{ zIndex: 10 }}>
        <Col md="2" lg="3">
          <Label>Fecha de Expiración *:</Label>
        </Col>
        <Col md="9">
          <DatePicker
            selected={
              input.value
                ? moment.parseZone(new Date(input.value), "DD/MM/YYYY")
                : null
            }
            onChange={input.onChange}
            className={className}
            dateFormat={"DD/MM/YYYY"}
            showYearDropdown
            showMonthDropdown
            locale="es-PE"
            minDate={moment(new Date())}
          />
          {hasError && <FormFeedback className="d-block">{error}</FormFeedback>}
        </Col>
      </FormGroup>
    );
  }

  renderInputField(field) {
    const {
      meta: { touched, error },
    } = field;
    const hasError = touched && error ? true : false;
    const labelClass = field.labelClass ? field.labelClass : "mt-1";

    return (
      <FormGroup row>
        <Col md="2" lg="3">
          <Label className={labelClass}>{field.label}</Label>
        </Col>
        <Col>
          <Input {...field.input} invalid={hasError} type={field.type} />
          {hasError && <FormFeedback className="d-block">{error}</FormFeedback>}
        </Col>
      </FormGroup>
    );
  }

  renderStaticField(field) {
    const {
      meta: { touched, error },
    } = field;
    const hasError = touched && error ? true : false;
    const labelClass = field.labelClass ? field.labelClass : "mt-1";

    return (
      <FormGroup row>
        <Col md="2" lg="3">
          <Label className={labelClass}>{field.label}</Label>
        </Col>
        <Col>
          <Input
            {...field.input}
            invalid={hasError}
            type={field.type}
            readOnly
          />
          {hasError == true ? <FormFeedback>{error}</FormFeedback> : null}
        </Col>
      </FormGroup>
    );
  }
  checkItemsChange() {
    const { selectedProducts, selectedServices } = this.props;
    if (selectedProducts || selectedServices) {
      let totalPrice = 0;

      selectedProducts.forEach((product) => {
        totalPrice += parseFloat(product.price);
      });

      selectedServices.forEach((service) => {
        totalPrice += parseFloat(service.price);
      });
      this.props.changeValueForm(
        "OfferAddForm",
        "totalPrice",
        formatHelper.toTwoDecimal(totalPrice)
      );
    }
  }

  renderTypeField(field) {
    const {
      meta: { touched, error },
    } = field;
    const hasError = touched && error ? true : false;

    console.log(field);

    return (
      <FormGroup row>
        <Col md="2" lg="3">
          <Label htmlFor="select">Tipo:</Label>
        </Col>
        <Col>
          <Input {...field.input} type="select" invalid={hasError}>
            {["PAQUETE", "OFERTA"].map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </Input>
          {hasError == true ? <FormFeedback>{error}</FormFeedback> : null}
        </Col>
      </FormGroup>
    );
  }

  render() {
    const { handleSubmit, isLoading, modalOpen } = this.props;

    const addButtonsDisabled = isLoading || modalOpen;

    return (
      <Form onSubmit={handleSubmit(handleSubmit(this.onSubmitOffer))}>
        <Field
          name="name"
          label="Nombre Descuento *:"
          type="text"
          component={this.renderInputField}
        />
        <Field name="type" component={this.renderTypeField} />
        <Field
          name="startDate"
          label="Fecha de Inicio *:"
          type="text"
          component={this.renderStartDatePicker}
        />
        <Field
          name="expirationDate"
          label="Fecha de Expiración *:"
          type="text"
          component={this.renderExpirationDatePicker}
        />
        <Field
          name="totalPrice"
          label="Precio Total:"
          type="text"
          component={this.renderStaticField}
        />
        {this.props.withCurrentImage
          ? this.renderOfferImage()
          : this.renderInputFile()}
        <Row>
          <Col className="mt-3">
            <Button
              onClick={() => this.toggleModal("Productos")}
              disabled={addButtonsDisabled}
              color="primary"
              className="mr-2"
            >
              <i className="icon-layers" /> Añadir Producto
            </Button>
            <Button
              onClick={() => this.toggleModal("Servicios")}
              disabled={addButtonsDisabled}
              color="primary"
              className="mr-2"
            >
              <i className="icon-tag" /> Añadir Servicio
            </Button>
          </Col>
          <Col className="nav justify-content-end mt-3">
            <Button
              type="submit"
              disabled={isLoading}
              color="primary"
              className="mr-2"
            >
              <i className="fa fa-save mr-1" /> Guardar
            </Button>
            <Button
              color="secondary"
              onClick={() => this.props.history.push("/administration/offers")}
            >
              <i className="fa fa-chevron-left mr-1" /> Cancelar
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}

FormOffer.propTypes = {
  onSubmitOffer: PropTypes.func,
  toggleModal: PropTypes.func,
  itemType: PropTypes.string,
  modalOpen: PropTypes.bool,
  isLoading: PropTypes.bool,
  changeImage: PropTypes.func,
  initialValues: PropTypes.object,
  withCurrentImage: PropTypes.bool,
  changeImageState: PropTypes.func,
};
const formSelector = formValueSelector("OfferAddForm");

function mapStateToProps(state) {
  return {
    startDate: formSelector(state, "startDate"),
    endDate: formSelector(state, "endDate"),
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      changeValueForm: change,
    },
    dispatch
  );
}
export default reduxForm({
  form: "OfferAddForm",
  touchOnBlur: false,
  // keepDirtyOnReinitialize: true,
  // enableReinitialize: true,
  validate: validateOffer,
})(connect(mapStateToProps, mapDispatchToProps)(withRouter(FormOffer)));



// WEBPACK FOOTER //
// ./src/scenes/Administration/Offer/OfferEdit/Forms/FormOffer.js